import { cn } from '@spiaggeit/spit-ui'
import { memo, useEffect } from 'react'
import { useMediaQuery } from 'usehooks-ts'

import { useAppDispatch, useAppSelector } from '@/hooks/store.ts'
import { isKioskSelector } from '@/store/appSlice.ts'
import { cartSlice } from '@/store/cartSlice/index.ts'
import { BREAKPOINTS } from '@/utils/breakpoints.ts'

import { LegendDialog } from '../../routes/Map/LegendDialog.tsx'

import { CartMobileSheet } from './CartMobileSheet/CartMobileSheet.tsx'
import { CartOverview } from './CartOverview/CartOverview.tsx'
import { ZoomButtons } from './ZoomButtons.tsx'

type Props = React.PropsWithoutRef<{
  className?: string
  nextPath?: string
  zoomIn?: VoidFunction
  zoomOut?: VoidFunction
}>

export const CartFooter = memo(function CartFooter(props: Props) {
  const cartItems = useAppSelector(cartSlice.selectors.items)
  const cartItemsLength = Object.keys(cartItems).length
  const dispatch = useAppDispatch()
  const cartPopoverIsOpen = useAppSelector(
    cartSlice.selectors.cartPopoverIsOpen
  )
  const isKiosk = useAppSelector(isKioskSelector)
  const isDesktop = useMediaQuery(`(min-width: ${BREAKPOINTS.lg}px)`)

  useEffect(() => {
    if (cartItemsLength < 1) {
      setTimeout(() => {
        dispatch(cartSlice.actions.setCartPopoverIsOpen(false))
      }, 200)
    }
  }, [dispatch, cartItemsLength])

  useEffect(() => {
    dispatch(cartSlice.actions.setCartPopoverIsOpen(false))
  }, [])

  return (
    <footer
      className={cn(
        'sticky bottom-0 z-10 mt-auto bg-white py-4 shadow-inverted',
        { 'rounded-none': cartPopoverIsOpen },
        props.className
      )}
    >
      <div
        className={cn('flex gap-4', {
          container: !isKiosk,
          'px-4': isKiosk,
        })}
      >
        {!isDesktop ? <CartMobileSheet nextPath={props.nextPath} /> : null}

        {!isKiosk && props.zoomIn && props.zoomOut ? (
          <div className="hidden items-center gap-4 lg:flex">
            <ZoomButtons zoomIn={props.zoomIn} zoomOut={props.zoomOut} />

            <LegendDialog />
          </div>
        ) : null}

        <CartOverview nextPath={props.nextPath} />
      </div>
    </footer>
  )
})
